import { CheckCircle } from "phosphor-react"
import { Typography, FormControl, Select, MenuItem } from "@mui/material"
import { Button } from "@material-ui/core"

const WebhookTable = () => {
  return (
    <div style={{ border: "1px solid red", height: "100%" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <CheckCircle weight="fill" color="#00FF444D" size={20} />
          <Typography sx={{ fontSize: "14px !important" }}>
            https://somewebhookurl.com/afghskdjdjdkvnnckk
          </Typography>
        </div>

        <div style={{ display: "flex", gap: "8px" }}>
          <FormControl fullWidth size="small">
            <Select
              // value={contentType}
              // onChange={(e) => setContentType(e.target.value)}
              sx={{
                backgroundColor: "#252A38",
                borderRadius: "10px",
                color: "#F9F9F9",
                "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                "& .MuiSelect-icon": { color: "#B1B5C9" },
              }}
              MenuProps={{
                PaperProps: {
                  sx: { backgroundColor: "#252A38", color: "#F9F9F9" },
                },
              }}
            >
              {["All Statuses", 2, 3, 4, 5, 6, 7, 8, 9, 10].map((ct) => (
                <MenuItem key={ct} value={ct} sx={{ fontSize: "13px" }}>
                  {ct}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button variant="outlined" color="secondary">Edit</Button>
          <Button variant="outlined" style={{ border: "1px solid #D61F1F" }}>Delete</Button>
        </div>
      </div>
    </div>
  )
}

export default WebhookTable
